import { createAppThunk } from "integrations/redux/hooks"
import { closePlayback, openPlayback, togglePlayback } from "plugins/shared/playback/state/slice"
import { selectOpenPlaybackIds } from "plugins/shared/playback/state/selectors"
import {
    markAllVideoFlightsDismissed,
    markVideoFlightDismissed,
    markVideoFlightUndismissed,
} from "./slice"
import { selectOpenVideoFlights } from "./selectors"

export const openVideoFlight = createAppThunk<{ flightId: string }, void>(
    ({ flightId }, { dispatch }) => {
        dispatch(openPlayback({ id: flightId, type: "video" }))
        dispatch(markVideoFlightUndismissed({ flightId }))
    }
)

export const closeVideoFlight = createAppThunk<{ flightId: string }, void>(
    ({ flightId }, { dispatch }) => {
        dispatch(closePlayback({ id: flightId }))
        dispatch(markVideoFlightDismissed({ flightId }))
    }
)

export const toggleVideoFlight = createAppThunk<{ flightId: string }, void>(
    ({ flightId }, { dispatch, getState }) => {
        const isOpen = selectOpenPlaybackIds(getState()).includes(flightId)
        dispatch(togglePlayback({ id: flightId, type: "video" }))
        dispatch(
            isOpen
                ? markVideoFlightDismissed({ flightId })
                : markVideoFlightUndismissed({ flightId })
        )
    }
)

export const closeAllVideoFlights = createAppThunk<void, void>((_, { dispatch, getState }) => {
    const openFlightIds = selectOpenVideoFlights(getState())
    openFlightIds.forEach((flightId) => dispatch(closePlayback({ id: flightId })))
    dispatch(markAllVideoFlightsDismissed({ flightIds: openFlightIds }))
})
